module.exports = __webpack_public_path__ + "static/img_escritorio-d92b19d46286be52dbc0b67a7ab25766.jpg";